export default __webpack_public_path__ + "static/media/Diamond_Edge_large_10.4050870b.jpg";